import { combineReducers } from "redux";
import Feed from "./feed/reducers";
const collections = {
  Feed,
};
export default combineReducers(collections);
